import styled from 'styled-components';

export const ContainerModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  background: ${({ theme }) => theme.white};
  border-radius: 8px;
  padding: 1rem;
  width: 650px;

  h6 {
    font-weight: bold;
    color: #000;
  }

  @media (max-width: 425px) {
    // Mobile L
    width: 400px;
  }
  @media (max-width: 375px) {
    // Mobile M
    width: 350px;
  }
  @media (max-width: 320px) {
    // Mobile S
    width: 300px;
  }
`;

export const AreaButtons = styled.div`
  display: flex;
  justify-content: center;
  gap: 1rem;
`;

export const RatingLabelInvalid = styled.span`
  font-weight: 400;
  line-height: 1.66;
  color: #f44336;
  font-size: 13px;
`;

export const ContainerContentEvaluate = styled.div`
  background: ${({ theme }) => theme.pantone656C};
  padding: 1rem;
  border-radius: 8px;
  width: 100%;
  overflow-y: auto;
  max-height: 450px;
`;

export const ContainerContentView = styled.div`
  background: ${({ theme }) => theme.pantone656C};
  padding: 1rem;
  border-radius: 8px;
  width: 100%;
`;

export const ContainerTextDescription = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  margin-top: 15px;
`;

export const TextDescription = styled.span`
  margin-bottom: 5px;
`;

export const ContainerMessage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 15px;
`;

interface ICustomColumn {
  $width?: string;
}
export const CustomColumn = styled.div<ICustomColumn>`
  width: 100%;
  max-width: ${({ $width }) => $width || '100%'};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const TextAreaReadonly = styled.div`
  padding: 10px;
  background-color: #fff;
  overflow: hidden;
  word-break: break-all;
  border-radius: 5px;
  white-space: pre-line;
`;

export const ContainerPartInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

interface IContainerPartInfoItemTooltip {
  $customWidth?: number;
}
export const ContainerPartInfoItemTooltip = styled.p<
  IContainerPartInfoItemTooltip
>`
  width: 100%;
  max-width: ${({ $customWidth }) => `${$customWidth}px` || '200px'};
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  margin: 0;
`;

export const ContainerAlertMessage = styled.div`
  font-weight: bold;
  font-size: 0.95rem;
  color: #000;
  display: flex;
  justify-content: center;
  text-align: center;
`;
